import { useRef } from 'react';

import { HSpacing, TooltipHover } from '@hh.ru/magritte-ui';
import { CheckCircleFilledSize16 } from '@hh.ru/magritte-ui/icon';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import VerticallyCentredIconSize16 from 'src/components/VerticallyCentredIconSize16';
import translation from 'src/components/translation';

const TrlKeys = {
    tooltipText: 'rb.view.phone.verified',
};

const VerifiedPhoneIcon: TranslatedComponent = ({ trls }) => {
    const activatorRef = useRef<HTMLSpanElement>(null);

    return (
        <>
            <TooltipHover placement="top-center" activatorRef={activatorRef}>
                {trls[TrlKeys.tooltipText]}
            </TooltipHover>
            <span ref={activatorRef}>
                <VerticallyCentredIconSize16 icon={<CheckCircleFilledSize16 initialColor="tertiary" />} />
            </span>
            <HSpacing default={8} />
        </>
    );
};

export default translation(VerifiedPhoneIcon);
